import React from 'react'
import { Contract } from '../../../types'

interface ContractStageCountProps {
    contract: Contract
    theme: string
}

const STAGE = ['Создание', 'Исполнение договора', 'Договор закрыт']

const ContractStage: React.FC<ContractStageCountProps> = ({
    contract,
    theme,
}) => {
    const STATUS_COLOR =
        theme == 'dark'
            ? new Map([
                  ['Договор на исполнении', '#049664'],
                  ['Просрочен', '#a85252'],
                  ['Исполнение договора завершено', '#515055'],
                  ['Договор расторгнут', '#515055'],
                  ['Исполнение договора прекращено', '#515055'],
                  ['Осталось меньше 10 дней', '#aa8c08'],
                  ['Осталось меньше 5 дней', '#d5701d'],
                  ['Возможно исполнен', '#aa8c08'],
                  ['Недействительно', '#515055'],
              ])
            : new Map([
                  ['Договор на исполнении', '#83d2b7'],
                  ['Просрочен', '#ed9cae'],
                  ['Исполнение договора завершено', '#cfd6e2'],
                  ['Договор расторгнут', '#cfd6e2'],
                  ['Исполнение договора прекращено', '#cfd6e2'],
                  ['Осталось меньше 10 дней', '#e0c963'],
                  ['Осталось меньше 5 дней', '#d5701d'],
                  ['Возможно исполнен', '#e0c963'],
                  ['Недействительно', '#cfd6e2'],
              ])

    const STAGE_COLOR =
        theme == 'dark'
            ? new Map([
                  ['Создание', '#049664'],
                  ['Исполнение договора', '#067d54'],
                  ['Договор закрыт', '#515055'],
              ])
            : new Map([
                  ['Создание', '#049664'],
                  ['Исполнение договора', '#41c497'],
                  ['Договор закрыт', '#cfd6e2'],
              ])

    let complete_stage = true
    return (
        <>
            <div className="relative flex flex-row w-[1710px] h-[90px] z-0 bg-[#e5e5e5] dark:bg-[#000000]">
                <svg className="flex absolute w-full h-full">
                    <line
                        x1="280"
                        y1="45"
                        x2="1430"
                        y2="45"
                        stroke={theme == 'dark' ? '#464447' : '#6A6A6A'}
                        strokeWidth="1"
                        strokeDasharray="5 5"
                    />
                </svg>
                <div className="flex w-full h-full z-20 absolute">
                    {STAGE.map((stage, index) => (
                        <div
                            key={index}
                            className="flex flex-col flex-1 justify-center items-center"
                        >
                            <div
                                className={`flex w-full h-full justify-center items-end ${complete_stage ? (stage == contract.contract_stage ? 'text-[12.8px] text-[#181818] dark:text-[#FFFFFF] ' : 'text-[10px] text-[#181818] dark:text-[#FFFFFF] ') : ' text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A]'}`}
                            >
                                {stage}
                            </div>
                            <div className="flex w-full h-full justify-center items-center">
                                <svg width="24" height="24">
                                    {complete_stage ? (
                                        stage == 'Исполнение договора' ? (
                                            <>
                                                <circle
                                                    cx="12"
                                                    cy="12"
                                                    r="6"
                                                    fill={`${STATUS_COLOR.get(String(contract.contract_status))}`}
                                                />
                                                <circle
                                                    cx="12"
                                                    cy="12"
                                                    r="8"
                                                    fill="none"
                                                    stroke={`${STATUS_COLOR.get(String(contract.contract_status))}55`}
                                                    strokeWidth="5"
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <circle
                                                    cx="12"
                                                    cy="12"
                                                    r="6"
                                                    fill={`${STAGE_COLOR.get(String(stage))}`}
                                                />
                                                <circle
                                                    cx="12"
                                                    cy="12"
                                                    r="8"
                                                    fill="none"
                                                    stroke={`${STAGE_COLOR.get(String(stage))}55`}
                                                    strokeWidth="5"
                                                />
                                            </>
                                        )
                                    ) : (
                                        <>
                                            <circle
                                                cx="12"
                                                cy="12"
                                                r="6"
                                                fill={
                                                    theme == 'dark'
                                                        ? '#464447'
                                                        : '#6A6A6A'
                                                }
                                            />
                                        </>
                                    )}
                                </svg>
                            </div>
                            <div
                                className={`flex w-full h-full justify-center items-start ${complete_stage ? 'text-[12.8px] text-[#181818] dark:text-[#FFFFFF] ' : ' text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A]'}`}
                            >
                                {stage == contract.contract_stage
                                    ? contract.contract_status
                                    : ''}
                            </div>
                            {stage == contract.contract_stage
                                ? (complete_stage = false)
                                : ''}
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default ContractStage
